<template>
    <Head>
        <title>Wakaf Pahang - Senarai Projek</title>
        <link rel="shortcut apple-touch-icon icon" :href="img_favicon" type="image/png">
    </Head>
    <section ref="header" class="container-fluid py-3 position-fixed top-0 bg-wakaf-primary" style="z-index: 5">
        <div class="row">
            <h1 class="fs-3 text-center text-white" >Senarai Projek Wakaf</h1>
        </div>
    </section>
    <section ref="body" class="container-fluid">
        <div class="row">
            <div class="d-flex flex-column col-md-12">
                <span class="fs-4 fw-bold">Senarai projek dalam yang aktif dan tidak aktif</span>
                <span class="fs-6">Untuk set projek tidak aktif, perlu set tarikh tamat projek</span>
                <span class="fs-6">Susunan projek mengikut tarikh mula dari terkini</span>
            </div>
        </div>
        <div class="row mt-4">
            <div class="row justify-content-center">
                <div class="d-flex justify-content-between overflow-x-auto mb-3">
                    <!--<p>{{ $page.props.flash.message}}</p>-->
                    <Link replace class="btn btn-outline-primary" :href="uri_create">Tambah</Link>
                    <nav class="d-inline-block">
                        <ul class="pagination" style="margin: 0" v-if="projects.length !== 0">
                            <li class="page-item disabled" v-if="paginator.current_page === 1">
                                <span class="page-link">...</span>
                            </li>
                            <li class="page-item" v-if="paginator.current_page !== 1">
                                <Link replace class="page-link" :href="paginator.prev_page_url">Sebelum</Link>
                            </li>
                            <template v-for="(page, index) in paginator.links">
                                <li class="page-item" v-if="page.url !== '' && !page.active && index !== 0 && index !== Object.keys(paginator.links).length-1">
                                    <Link replace class="page-link" :href="page.url">{{ page.label }}</Link>
                                </li>
                                <li class="page-item active" v-if="page.active">
                                    <Link replace class="page-link" :href="page.url">{{ page.label }}</Link>
                                </li>
                            </template>
                            <li class="page-item" v-if="paginator.current_page !== paginator.last_page">
                                <Link replace class="page-link" :href="paginator.next_page_url">Seterusnya</Link>
                            </li>
                            <li class="page-item disabled" v-if="paginator.current_page === paginator.last_page">
                                <span class="page-link">...</span>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div>

                </div>
                <div class="table-responsive">
                    <table class="table table-bordered table-striped" >
                        <thead class="table-dark">
                        <tr>
                            <th>No</th>
                            <th>Kod</th>
                            <th>Projek</th>
                            <th>Jenis Projek</th>
                            <th>Daerah</th>
                            <th>Jumlah kutipan (RM)</th>
                            <th>Jumlah digunakan (RM)</th>
                            <th>Sasaran (RM)</th>
                            <th>Baki (RM)</th>
                            <th>Tarikh Mula</th>
                            <th>Tarikh Akhir</th>
                            <th>Susunan</th>
                            <th>Tindakan</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(project, index) in projects">
                            <td>{{ ((paginator.current_page-1) * paginator.per_page)+index+1 }}</td>
                            <td>{{ project.id }}</td>
                            <td>{{ project.projek }}</td>
                            <td>{{ project.jenisWakaf }}</td>
                            <td>{{ project.daerahWakaf }}</td>
                            <td>{{ sumFormatWithoutCurrency(project.jumlahKutip) }}</td>
                            <td>{{ sumFormatWithoutCurrency(project.jumlahGuna) }}</td>
                            <td>{{ sumFormatWithoutCurrency(project.sasaran) }}</td>
                            <td>{{ sumFormatWithoutCurrency(project.baki) }}</td>
                            <td>{{ (project.tarikhMula.match(/^[0-9]{4}(-)[0-9]{2}(-)[0-9]{2}$/gm) === null)? project.tarikhMula: formatDateOnly(project.tarikhMula) }}</td>
                            <td>{{ (project.tarikhAkhir.match(/^[0-9]{4}(-)[0-9]{2}(-)[0-9]{2}$/gm) === null)? project.tarikhAkhir: formatDateOnly(project.tarikhAkhir) }}</td>
                            <td>{{ project.susunan }}</td>
                            <td>
                                <Link replace v-if="!noEdit.has(project.id)" class="btn btn-outline-wakaf-primary" :href="project.uri_edit">
                                    <div class="d-flex flex-row">
                                        <font-awesome-icon :icon="faPenToSquare" />
                                        <span class="fs-6 ms-1" style="margin-top: -4px;">Sunting</span>
                                    </div>
                                </Link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import {onMounted, Ref, ref} from "vue";
import {Head, Link, usePage} from "@inertiajs/vue3";
import {PageProps} from "@inertiajs/core";
import {formatDateOnly, sumFormatWithoutCurrency} from "../../../utils/utils";
import Swal from "sweetalert2";
import {faPenToSquare, faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
library.add(faPenToSquare);
library.add(faPlus);

interface Data{
    id: number,
    projek: string,
    sasaran: number,
    jumlahKutip: number,
    jumlahGuna: number,
    baki: number,
    tarikhMula: string,
    tarikhAkhir: string,
    susunan: string,
    jenisWakaf: string,
    daerahWakaf: string,
    uri_edit: string,
}

const data = defineProps<{
    csrf: string,
    img_favicon: string,
    projects: Data[],
    uri_create: string,
    paginator:  {
        current_page: number,
        data: Data[],
        first_page_url: string,
        from: number,
        last_page: number,
        last_page_url: string,
        links:[{
            active: boolean,
            label: string,
            url: string,
        }],
        next_page_url: string,
        path: string,
        per_page: number,
        prev_page_url: string,
        to: number,
        total: number
    },
}>();

const header: Ref = ref<HTMLDivElement>();
const body: Ref = ref<HTMLDivElement>();
//const bodys = $page.props;
const noEdit = new Set([3,5,26]);

interface ServerInfo extends PageProps {
    flash:{
        message: string | null
    } | null
}
onMounted(() => {
    body.value.style.marginTop = header.value.clientHeight+10 +"px";
    window.addEventListener("resize", ()=>{
        body.value.style.marginTop = header.value.clientHeight+10 +"px";
    });
    const message = (usePage().props as unknown) as ServerInfo;
    if (message.flash?.message !== null){
        Swal.fire({
            position: "top-right",
            icon: "success",
            title: message.flash?.message,
            timer: 1500
        });
    }
});
</script>

<style scoped>
</style>
